import React, { useState, useRef, useEffect } from 'react';
import { Button, FormControlLabel, Radio, RadioGroup, Dialog, DialogContent } from "@mui/material";
import './Editor.css';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { PleasewaitPopup } from '../../../../components/PleasewaitPopup';
import { baseURL } from "../../../../config/api";
import colorConfigs from '../../../../config/colorConfigs';
import useAuth from '../../../../hook/useAuth';
import useDelete from '../../../../hook/useDelete';
import { validateMin } from '../../../../utils/validateMin';
import saveAs from 'file-saver';
import Webcam from 'react-webcam';
import { CustomImagePopup } from '../../../../components/CustomImagePopup';
import { handleCapture } from '../../../../utils/handleCapture';

export const EditPaymentGatewaysForm = () => {
    const { auth }: any = useAuth();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [paymentGateways, setPaymentGateways] = useState<any[]>([]);
    const [isAuthentication, setIsAuthentication] = useState<boolean>(true);
    const [isWebsite, setIsWebsite] = useState<boolean>(true);
    const [paymentGateWayMenuItemId, setPaymentGateWayMenuItemId] = useState<string>("");
    const [label, setLabel] = useState<string>("");
    const [supportedCurrencies, setSupportedCurrencies] = useState<string>("");
    const [defaultCurrency, setDefaultCurrency] = useState<string>("");
    const [apiLoginId, setApiLoginId] = useState<string>("");
    const [transactionKey, setTransactionKey] = useState<string>("");
    const [publicKey, setPublicKey] = useState<string>("");
    const [active, setActive] = useState<string>("No");
    const [threeDsEnabled, setThreeDsEnabled] = useState<string>("No");
    const [skipCreditCardStorage, setSkipCreditCardStorage] = useState<string>("No");
    const [collectBillingAddress, setCollectBillingAddress] = useState<string>("No");
    const [onlyInternalCharges, setOnlyInternalCharges] = useState<string>("No");
    const [allowprocessingpaymentsAfterDeactivation,
        setAllowprocessingpaymentsAfterDeactivation] = useState<string>("No");
    const [testMode, setTestMode] = useState<string>("No");
    const [onlyPublicCharges, setOnlyPublicCharges] = useState<string>("No");
    const [authorizedUserRoles, setAuthorizedUserRoles] = useState<string>("");
    const [order, setOrder] = useState<string>("");
    const [commentforForm, setCommentforForm] = useState<string>("");
    const [textforPaymentButtonOnForm, setTextforPaymentButtonOnForm] = useState<string>("");
    const [textforAuthorizationButtonOnForm, setTextforAuthorizationButtonOnForm] = useState<string>("");
    const [textForSaveCreditCardButtonOnForm, setTextForSaveCreditCardButtonOnForm] = useState<string>("");
    const [filePath, setFilePath] = useState<string>("");
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [customCss, setCustomCss] = useState<string>('');
    const customCssLines = customCss.split('\n').length;

    const [customHtmlAfterBody, setCustomHtmlAfterBody] = useState<string>('');
    const customHtmlAfterBodyLines = customHtmlAfterBody.split('\n').length;

    const [customHtmlBeforeBody, setCustomHtmlBeforeBody] = useState<string>('');
    const customHtmlBeforeBodyLines = customHtmlBeforeBody.split('\n').length;

    const [showWebcam, setShowWebcam] = useState<boolean>(false);

    const webRef = useRef(null);
    const inputFileRef = useRef<HTMLInputElement>(null);
    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: false,
                })
                .then((response) => {
                    setFilePath(response.data);
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });

        } else {
            setPleaseWaitPopup(false);
        }
    };

    const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);
            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: false,
                })
                .then((response) => {
                    setFilePath(`${baseURL}commonFile/Get?name=${response.data}`)
                    axios
                        .put(`${baseURL}paymentGateways?userId=${auth?.id}`, JSON.stringify({
                            id: state,
                            paymentGateWayMenuItemId,
                            label,
                            supportedCurrencies,
                            defaultCurrency,
                            publicClientKey: publicKey,
                            transactionKey,
                            apiLoginId,
                            isActive: active === "Yes" ? true : false,
                            testMode: testMode === "Yes" ? true : false,
                            skipCreditCardStorage: skipCreditCardStorage === "Yes" ? true : false,
                            collectBillingAddress: collectBillingAddress === "Yes" ? true : false,
                            onlyInternalCharges: onlyInternalCharges === "Yes" ? true : false,
                            onlyPublicCharges: onlyPublicCharges === "Yes" ? true : false,
                            allowprocessingpaymentsAfterDeactivation: allowprocessingpaymentsAfterDeactivation === "Yes" ? true : false,
                            authorizedUserRoles,
                            imagesName: response.data,
                            order,
                            customCSS: customCss,
                            customHTMLAfterBody: customHtmlAfterBody,
                            customHTMLBeforeBodyCloseTag: customHtmlBeforeBody,
                            commentforForm,
                            textforPaymentButtonOnForm,
                            textforAuthorizationButtonOnForm,
                            textForSaveCreditCardButtonOnForm,
                        }), {
                            headers: {
                                "Content-Type": "application/json"
                            },
                            withCredentials: false,
                        })
                        .then(() => {
                            setPleaseWaitPopup(false);
                        })
                        .catch((error) => {
                            setPleaseWaitPopup(false);
                        });
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });
        } else {
            setPleaseWaitPopup(false);
        }

    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        await axios
            .put(`${baseURL}paymentGateways?userId=${auth?.id}`, JSON.stringify({
                id: state,
                paymentGateWayMenuItemId,
                label,
                supportedCurrencies,
                defaultCurrency,
                publicClientKey: publicKey,
                transactionKey,
                apiLoginId,
                isActive: active === "Yes" ? true : false,
                testMode: testMode === "Yes" ? true : false,
                skipCreditCardStorage: skipCreditCardStorage === "Yes" ? true : false,
                collectBillingAddress: collectBillingAddress === "Yes" ? true : false,
                onlyInternalCharges: onlyInternalCharges === "Yes" ? true : false,
                onlyPublicCharges: onlyPublicCharges === "Yes" ? true : false,
                allowprocessingpaymentsAfterDeactivation: allowprocessingpaymentsAfterDeactivation === "Yes" ? true : false,
                authorizedUserRoles,
                imagesName: filePath,
                order,
                customCSS: customCss,
                customHTMLAfterBody: customHtmlAfterBody,
                customHTMLBeforeBodyCloseTag: customHtmlBeforeBody,
                commentforForm,
                textforPaymentButtonOnForm,
                textforAuthorizationButtonOnForm,
                textForSaveCreditCardButtonOnForm,
            }), {
                headers: {
                    "Content-Type": "application/json"
                },
                withCredentials: false,
            })
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
            });
    };

    useEffect(() => {
        axios
            .get(`${baseURL}paymentGatewayMenus`)
            .then(response => {
                setPaymentGateways(
                    response.data.map((item: any) => {
                        return {
                            id: item.id,
                            provider: item.provider
                        }
                    }));
            })
            .catch(() => {
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setPleaseWaitPopup(true);
        axios
            .get(`${baseURL}paymentGateways/${state}`)
            .then((response) => {
                setPaymentGateWayMenuItemId(response.data.paymentGateWayMenuItemId);
                setLabel(response.data.label);
                setSupportedCurrencies(response.data.supportedCurrencies);
                setDefaultCurrency(response.data.defaultCurrency);
                setPublicKey(response.data.publicClientKey);
                setTransactionKey(response.data.transactionKey);
                setApiLoginId(response.data.apiLoginId);
                setActive(response.data.isActive ? "Yes" : "No");
                setTestMode(response.data.testMode ? "Yes" : "No");
                setSkipCreditCardStorage(response.data.skipCreditCardStorage ? "Yes" : "No");
                setCollectBillingAddress(response.data.collectBillingAddress ? "Yes" : "No");
                setOnlyInternalCharges(response.data.onlyInternalCharges ? "Yes" : "No");
                setOnlyPublicCharges(response.data.onlyPublicCharges ? "Yes" : "No");
                setAllowprocessingpaymentsAfterDeactivation(response.data.allowprocessingpaymentsAfterDeactivation ? "Yes" : "No");
                setAuthorizedUserRoles(response.data.authorizedUserRoles);
                setFilePath(response.data.imagesName);
                setOrder(response.data.order);
                setCustomCss(response.data.customCSS);
                setCustomHtmlAfterBody(response.data.customHTMLAfterBody);
                setCustomHtmlBeforeBody(response.data.customHTMLBeforeBodyCloseTag);
                setCommentforForm(response.data.commentforForm);
                setTextforPaymentButtonOnForm(response.data.textforPaymentButtonOnForm);
                setTextforAuthorizationButtonOnForm(response.data.textforAuthorizationButtonOnForm);
                setTextForSaveCreditCardButtonOnForm(response.data.textForSaveCreditCardButtonOnForm);
                setPleaseWaitPopup(false);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const downloadTheImage = () => {
        if (filePath.startsWith("data:image/png")) {
            handleConvertClick(filePath.replace("data:image/png;base64,", ""));
        } else {
            saveAs(
                `${baseURL}commonFile/download?name=${filePath}`,
                `${state.provider}.png`
            );
        }
    };

    const handleConvertClick = (base64Image: string) => {
        const byteCharacters = atob(base64Image);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/png' });

        saveAs(blob, `${state.provider}.png`);
    };

    const deleteThePaymentGateway = () => {
        setDeleteData({
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Payment Gateway?`,
            isDelete: (callback: any) => {
                callback();

                setPleaseWaitPopup(true);

                fetch(`${baseURL}paymentGateways?id=${state}&userId=${auth?.id}`, {
                    method: 'DELETE',
                })
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setPleaseWaitPopup(false);
                    });
            }
        });

        setDeletePopup(true);
    };

    const handleEdit = () => {
        setDisabled(false);
        setShowWebcam(false);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>
                            <div className={`flex justify-between items-center p-2 border-b border-secondary`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold text-secondary`}>Edit Payment Gateway - {paymentGateways.find((item: any) => item.id === parseInt(paymentGateWayMenuItemId))?.provider}</h2>
                                </div>

                                {
                                    disabled && (
                                        <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border border-secondary text-white flex items-center gap-1.5`}
                                            onClick={handleEdit}
                                        >
                                            <span className={`material-symbols-outlined text-[25px] font-light text-secondary`}>
                                                edit
                                            </span>
                                            <span className={`text-xs font-medium text-secondary`}>Edit</span>
                                        </button>
                                    )
                                }
                            </div>

                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium text-secondary`}>Label</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                        value={label}
                                                        disabled={disabled}
                                                        onChange={(e) => setLabel(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium text-secondary`}>Supported Currencies</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                        value={supportedCurrencies}
                                                        disabled={disabled}
                                                        onChange={(e) => setSupportedCurrencies(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium invisible text-secondary`}>Supported Currencies</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md invisible border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium text-secondary`}>Default Currency</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                        value={defaultCurrency}
                                                        disabled={disabled}
                                                        onChange={(e) => setDefaultCurrency(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <h5 className="mb-0 mt-4 flex justify-start items-center cursor-pointer select-none"
                                            onClick={() => setIsAuthentication(!isAuthentication)}
                                        >
                                            {isAuthentication ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                                                </svg>
                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M9.29 6.71 13.17 10.59 9.29 14.47 10.7 15.88 16.58 10 10.7 4.12z" />
                                                </svg>
                                            )}{" "}
                                            <div className="w-full flex flex-row justify-between items-center">
                                                <div style={{ color: "#2f3739" }}>Authentication</div>
                                            </div>
                                        </h5>
                                        <hr />

                                        {isAuthentication &&
                                            <div className="grid grid-cols-3 gap-6 mt-2">
                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Api Login ID</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                            value={apiLoginId}
                                                            disabled={disabled}
                                                            onChange={(e) => setApiLoginId(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Transaction Key</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                            value={transactionKey}
                                                            disabled={disabled}
                                                            onChange={(e) => setTransactionKey(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Active?</label>
                                                        <RadioGroup
                                                            row
                                                            value={active}
                                                            onChange={(e) => setActive(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>3DS Enabled</label>
                                                        <RadioGroup
                                                            row
                                                            value={threeDsEnabled}
                                                            onChange={(e) => setThreeDsEnabled(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Skip Credit Card Storage?</label>
                                                        <RadioGroup
                                                            row
                                                            value={skipCreditCardStorage}
                                                            onChange={(e) => setSkipCreditCardStorage(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Collect Billing Address</label>
                                                        <RadioGroup
                                                            row
                                                            value={collectBillingAddress}
                                                            onChange={(e) => setCollectBillingAddress(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Public Key</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                            value={publicKey}
                                                            disabled={disabled}
                                                            onChange={(e) => setPublicKey(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Authorized User Roles</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                            value={authorizedUserRoles}
                                                            disabled={disabled}
                                                            onChange={(e) => setAuthorizedUserRoles(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Test Mode</label>
                                                        <RadioGroup
                                                            row
                                                            value={testMode}
                                                            onChange={(e) => setTestMode(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Only Public</label>
                                                        <RadioGroup
                                                            row
                                                            value={onlyPublicCharges}
                                                            onChange={(e) => setOnlyPublicCharges(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Only Internal Charges</label>
                                                        <RadioGroup
                                                            row
                                                            value={onlyInternalCharges}
                                                            onChange={(e) => setOnlyInternalCharges(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium text-secondary`}>Allow Processing Payments for Saved Credit Cards After Deactivation</label>
                                                        <RadioGroup
                                                            row
                                                            value={allowprocessingpaymentsAfterDeactivation}
                                                            onChange={(e) => setAllowprocessingpaymentsAfterDeactivation(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": {
                                                                            color: "blue",
                                                                        },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    color: "#2f3739"
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <h5 className="mb-0 mt-4 flex justify-start items-center cursor-pointer select-none"
                                            onClick={() => setIsWebsite(!isWebsite)}
                                        >
                                            {isWebsite ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" />
                                                </svg>
                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="#2f3739"
                                                >
                                                    <path d="M9.29 6.71 13.17 10.59 9.29 14.47 10.7 15.88 16.58 10 10.7 4.12z" />
                                                </svg>
                                            )}{" "}
                                            <div className="w-full flex flex-row justify-between items-center">
                                                <div style={{ color: "#2f3739" }}>Website</div>
                                            </div>
                                        </h5>
                                        <hr />

                                        {isWebsite &&
                                            <>
                                                <div className="grid grid-cols-3 gap-6 mt-2">
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label
                                                                htmlFor="image"
                                                                style={{ fontSize: "12px", fontWeight: "bold" }}
                                                            >
                                                                Images
                                                                <br />
                                                                <div
                                                                    style={{
                                                                        maxWidth: "50%",
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        alignItems: "center",
                                                                        gap: "5px",
                                                                        cursor: "pointer"
                                                                    }}
                                                                    onClick={() => setImagePopup(true)}
                                                                >
                                                                    {filePath &&
                                                                        <>
                                                                            <img
                                                                                src={filePath.startsWith("data:image/png") ?
                                                                                    filePath
                                                                                    :
                                                                                    `${baseURL}commonFile/Get?name=${filePath}`}
                                                                                width={40}
                                                                                height={40}
                                                                                alt="mailBarLogo"
                                                                            />
                                                                        </>
                                                                    }
                                                                </div>
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    name="mailBarLogo"
                                                                    ref={inputFileRef}
                                                                    disabled={disabled}
                                                                    onChangeCapture={onFileChangeCapture}
                                                                    style={{ display: "none" }}
                                                                />
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        gap: "8px",
                                                                        marginTop: "8px",
                                                                    }}
                                                                >
                                                                    <p
                                                                        style={{
                                                                            border: "1px dashed black",
                                                                            borderRadius: "3px",
                                                                            padding: "3px 5px",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            fontSize: "12px",
                                                                            backgroundColor: "white",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={(e) => {
                                                                            if (inputFileRef.current !== null) {
                                                                                inputFileRef.current?.click();
                                                                            }
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        <svg
                                                                            className="text-[#167AC3] text-[14px] font-bold"
                                                                            style={{
                                                                                width: "14px",
                                                                                height: "14px",
                                                                            }}
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                d="M12 5V19"
                                                                                stroke="currentColor"
                                                                                strokeWidth="2"
                                                                                strokeLinecap="round"
                                                                            />
                                                                            <path
                                                                                d="M5 12H19"
                                                                                stroke="currentColor"
                                                                                strokeWidth="2"
                                                                                strokeLinecap="round"
                                                                            />
                                                                        </svg>
                                                                        Add Image
                                                                    </p>

                                                                    <p
                                                                        style={{
                                                                            border: "1px dashed black",
                                                                            borderRadius: "3px",
                                                                            padding: "3px 5px",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            fontSize: "12px",
                                                                            backgroundColor: "white",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() => setShowWebcam(true)}
                                                                    >
                                                                        {" "}
                                                                        <svg
                                                                            className="text-[#167AC3] text-[14px] font-bold"
                                                                            style={{
                                                                                width: "14px",
                                                                                height: "14px",
                                                                            }}
                                                                            viewBox="0 0 24 24"
                                                                            fill="currentColor"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 
             1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 
             14c-3.31 0-6-2.69-6-6s2.69-6 6-6 
             6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 
             0-4 1.79-4 4s1.79 4 4 4 
             4-1.79 4-4-1.79-4-4-4zm7.5-1.5l1.41-1.41L21.91 
             7l-1.41 1.41L19.5 7.5z" />
                                                                        </svg>
                                                                    </p>

                                                                    {filePath &&
                                                                        <p
                                                                            style={{
                                                                                border: "1px dashed black",
                                                                                borderRadius: "3px",
                                                                                padding: "3px 5px",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                fontSize: "12px",
                                                                                backgroundColor: "white",
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={() => downloadTheImage()}
                                                                        >
                                                                            {" "}
                                                                            <svg
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    color: "black",
                                                                                    fontWeight: "bold",
                                                                                    width: "14px",
                                                                                    height: "14px",
                                                                                }}
                                                                                viewBox="0 0 24 24"
                                                                                fill="currentColor"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path d="M19 9h-4V3H9v6H5l7 7 7-7z" />
                                                                                <path d="M5 18v2h14v-2H5z" />
                                                                            </svg>
                                                                        </p>
                                                                    }
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>Order</label>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                                value={order}
                                                                disabled={disabled}
                                                                onChange={(e) => setOrder(validateMin(e.target.value, 0).toString())}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium text-secondary`}>Custom CSS</label>
                                                    <div className="code-editor">
                                                        <div className="line-numbers">
                                                            {Array.from({ length: customCssLines }, (_, i) => (
                                                                <div key={i} className="line-number">
                                                                    {i + 1}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <textarea
                                                            className="code-input"
                                                            value={customCss}
                                                            disabled={disabled}
                                                            onChange={(e) => setCustomCss(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium text-secondary`}>Custom HTML After Body</label>
                                                    <div className="code-editor">
                                                        <div className="line-numbers">
                                                            {Array.from({ length: customHtmlAfterBodyLines }, (_, i) => (
                                                                <div key={i} className="line-number">
                                                                    {i + 1}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <textarea
                                                            className="code-input"
                                                            value={customHtmlAfterBody}
                                                            disabled={disabled}
                                                            onChange={(e) => setCustomHtmlAfterBody(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium text-secondary`}>Custom HTML Before Body Close Tag</label>
                                                    <div className="code-editor">
                                                        <div className="line-numbers">
                                                            {Array.from({ length: customHtmlBeforeBodyLines }, (_, i) => (
                                                                <div key={i} className="line-number">
                                                                    {i + 1}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <textarea
                                                            className="code-input"
                                                            value={customHtmlBeforeBody}
                                                            disabled={disabled}
                                                            onChange={(e) => setCustomHtmlBeforeBody(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="my-5">
                                                    <label className="text-xs font-medium text-secondary">
                                                        Comment For Form
                                                    </label>

                                                    <textarea
                                                        className="w-full border border-secondary bg-transparent text-secondary rounded-md p-3 text-sm resize-y outline-none focus:border-[#167AC3]"
                                                        rows={6}
                                                        value={commentforForm}
                                                        onChange={(e) => setCommentforForm(e.target.value)}
                                                    />
                                                </div>

                                                <div className="grid grid-cols-3 gap-6 mt-2">
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>Text For Payment Button on Form</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                                value={textforPaymentButtonOnForm}
                                                                disabled={disabled}
                                                                onChange={(e) => setTextforPaymentButtonOnForm(e.target.value)}
                                                                required
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>Text For Save Credit Card Button on Form</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                                value={textForSaveCreditCardButtonOnForm}
                                                                disabled={disabled}
                                                                onChange={(e) => setTextForSaveCreditCardButtonOnForm(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>Text For Authorization Button on Form</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                                value={textforAuthorizationButtonOnForm}
                                                                disabled={disabled}
                                                                onChange={(e) => setTextforAuthorizationButtonOnForm(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        <div className="flex gap-4 mt-6">
                                            {
                                                !disabled && (
                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.main.bg
                                                        }}
                                                        type="submit"
                                                    >
                                                        Save
                                                    </Button>
                                                )
                                            }

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color

                                                }}
                                                onClick={() => navigate(-1)}
                                            >
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.delete.bg,
                                                }}
                                                onClick={deleteThePaymentGateway}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={showWebcam && !disabled}
                maxWidth="md"
                fullScreen={false}
                PaperProps={{
                    style: {
                        marginTop: "-16%",
                    },
                }}
            >
                <DialogContent sx={{ padding: "0px" }}>
                    <Webcam
                        width={480}
                        height={320}
                        ref={webRef}
                        screenshotFormat="image/png"
                        audio={false}
                        disabled={disabled}
                    />

                    <div
                        style={{
                            width: "100%",
                            height: "50px",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingBlock: "8px",
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            backgroundColor: "#eeeeee",
                        }}
                    >
                        <div style={{ width: "50%" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                    border: colorConfigs.btn.cancel.border,
                                    color: colorConfigs.btn.cancel.color
                                }}
                                onClick={() => setShowWebcam(false)}
                            >
                                Cancel
                            </Button>
                        </div>

                        <div
                            style={{
                                width: "50%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: colorConfigs.topbar.bg,
                                    color: "white",
                                    borderRadius: "0",
                                    border: "none",
                                    textTransform: "capitalize",
                                    fontSize: "12px",
                                    "&: hover": {
                                        backgroundColor: colorConfigs.topbar.bg,
                                        color: "white",
                                    },
                                }}
                                onClick={() => {
                                    if (webRef.current !== null) {
                                        //@ts-ignore
                                        const imageSrc = webRef.current.getScreenshot();

                                        handleCapture(imageSrc, `${baseURL}commonFile/upload`, (imageFilePath: string) => {
                                            if (imageFilePath) {
                                                setFilePath(imageFilePath);
                                            }
                                        })

                                        setShowWebcam(false);
                                    }
                                }}
                            >
                                Capture an Image
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={`${baseURL}/commonFile/Get?name=${filePath}`}
                imageBaseUrlPath="commonFile"
                updateFile={updateFile}
            />

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}
